import { FC } from 'react';
import ManageTokens from 'components/elements/components/ManageTokens';

const Screen: FC = () => {
  return (
    <ManageTokens
      elementsEntityName="element-tokens"
      elementsEndpoint="tokens"
      fieldsEntityName="fields"
      fieldsEndpoint="fields"
      tokenIdKey="token_id"
      fieldIdKey="field_id"
      elementFilter="element_id"
    />
  );
};

export default Screen;
